import { Translation } from '@wix/answers-api';

import { Store } from '.';
import { PageDataArticle } from '../../components/PageTemplate';

export type ArticleSlice = {
  article?: PageDataArticle;
  translations?: Translation[];
  setArticleData: (data: {
    article?: PageDataArticle;
    translations?: Translation[];
  }) => void;
};

export const getArticleInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): ArticleSlice => ({
  article: undefined,
  translations: undefined,
  setArticleData: (data) => {
    set((state) => ({
      articleSlice: {
        ...state.articleSlice,
        ...data,
      },
    }));
  },
});
